/* io-worn-lq.js (founder 2026-11-03): the tall cell's photo stays loading="lazy" in the markup; this starts it about 2
   screens ahead and fades it in over its 48 px copy (snippets/io-worn-look .io-lq). Nothing stored or sent. */
(function (W, D) {
  if (W.IoWornLq) return;
  W.IoWornLq = 1;
  var still = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches,
    io = W.IntersectionObserver && new W.IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); e.target.loading = 'eager'; } });
    }, { rootMargin: '200% 0px' });
  [].forEach.call(D.querySelectorAll('img.io-lq+img'), function (i) {
    if (!still && !i.complete) {
      var f = function () { i.classList.add('is-in'); };
      i.classList.add('io-lq-f');
      i.addEventListener('load', f);
      i.addEventListener('error', f);
    }
    if (io) io.observe(i);
  });
}(window, document));
